import Vue from 'vue';
import App from './App';

/**
 * Element UI Library
 */
import './plugins/element';

/**
 * Input mask
 */
import './plugins/mask';

/**
 * Mobile device detect
 */
import './plugins/mobileDetection';

/**
 * Signature pad
 */
import './plugins/signature';

/**
 * Main stylesheet
 */
import './scss/main.scss';

/**
 * Global mixins
 */
import './services/mixins';

/**
 * Additional functions
 */
import './services/helpers';

/**
 * Router
 */
import router from './router';

/**
 * Vuex
 */
import store from './store/index';

/**
 * Axios instance
 */
import './services/api';

/**
 * i18n
 */
import i18n from './locales';

new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
  created () {
    const urlParams = new URLSearchParams(new URL(window.location.href).search.slice(1)),
          params = {};
    let routerName = '',
        uId = sessionStorage.getItem('userId');

    urlParams.forEach((el, index) => {
      Object.assign(params, { [index]: el });
    });

    //get sessionId from bookonline
    if (typeof uId !== 'undefined') {
      sessionStorage.setItem('sessionId', uId);
    }

    if (window.location.pathname.includes("pre")) {
      if (Object.keys(params).length) {
        window.history.replaceState(null, null, window.location.pathname);
        if (params.pid) {
          routerName = 'CheckIn';
          sessionStorage.setItem('checkInParam', 'pid');
        }
        if (params.epn) {
          routerName = 'CheckInLink';
          sessionStorage.setItem('checkInParam', 'epn');
        }
        sessionStorage.setItem('routerName', routerName);
        this.setRouter(routerName, params);
      } else {
        let hashParams = window.location.hash.split('/');
        if (Object.keys(hashParams).length == 2) {
          Object.assign(params, {[sessionStorage.getItem('checkInParam')]: hashParams[1]});
          this.setRouter(sessionStorage.getItem('routerName'), params);
        }
      }
    } else {
      if (Object.keys(params).length) {
        window.history.replaceState(null, null, window.location.pathname);
        if (params.pir) {
          routerName = 'Login';
        }
        if (params.pn) {
          let pathParams = window.location.pathname.slice(1).split('/'),
              pageName = pathParams[1],
              authSource = 'bookonline';

          if (pageName) {
            routerName = pageName.charAt(0).toUpperCase() + pageName.slice(1);
            Object.assign(params,{ patientNumber: params.pn });
            delete params['pn'];
            sessionStorage.setItem('authSource', authSource);
          }
        }
        this.setRouter(routerName, params);
      }
    }
  },
  methods: {
    setRouter(name, params) {
      return this.$router.push({
        name: name,
        params: params
      });
    }
  }
}).$mount('#bookonline-patient');
